import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <div data-testid="page-privacy" className="bg-white">
      <Seo title="Privacy Policy" description="How The Mogul Group Advisors handles information submitted through this website." path="/privacy" />
      <div className="container-wide py-20 max-w-3xl">
        <div className="overline mb-4">Legal</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight">Privacy Policy</h1>
        <div className="mt-8 space-y-6 text-[#4B5563] leading-relaxed text-[15px]">
          <p>The Mogul Group Advisors ("we", "us") respects your privacy. This policy describes what information we collect through this website and how we use it.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Information we collect</h2>
          <p>We collect information you voluntarily submit through our Growth Assessment or Contact forms — such as your name, business name, email, phone number, website, location, and details about your business needs.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">How we use your information</h2>
          <p>We use your information solely to evaluate your business needs, respond to your inquiry, and, if you choose to work with us, to deliver services you have requested. We do not sell your information.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Data security</h2>
          <p>Submissions are stored securely and access is limited to authorized team members.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Your choices</h2>
          <p>You may request access to, or deletion of, information you have submitted at any time by emailing info@TheMogulAdvisors.com.</p>
          <p className="text-xs text-[#6B7280] pt-4">This policy is provided for informational purposes and can be updated by the administrator.</p>
        </div>
      </div>
    </div>
  );
}
